import gql from 'graphql-tag';

export default gql`
  mutation updateEmail(
    $email: String!
  ) {
    updateEmail(
      email: $email
    ) {
      statusCode
      message
    }
  }
`;
